import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  Alert as MuiAlert,
  Button,
  TextField,
  DialogActions,
  Box,
  FormHelperText,
  CircularProgress,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import * as Yup from "yup";
import { spacing } from "@mui/system";
import styled from "@emotion/styled";

import { Formik } from "formik";
import { useDialog } from "../../../../contexts/DialogContext";
import useHotelManagement from "../../../../hooks/useHotelManagement";

const Alert = styled(MuiAlert)(spacing);

const Upload = ({ fetchData }) => {
  const { unSetDialog, openDialog } = useDialog();
  const {
    sampleFile,
    uploadFile,
    isUpload,
    isDownload,
    uploadError,
    uploadSuccess,
    uploadErrorMessage,
    resetUploadState,
  } = useHotelManagement();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  const clearFile = (setFieldValue) => {
    setFieldValue("file", null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  useEffect(() => {
    resetUploadState();
  }, []);

  const downloadSampleFile = () => {
    sampleFile("xlsx");
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{
        file: null,
        submit: null,
      }}
      validationSchema={Yup.object().shape({
        file: Yup.mixed().required(),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting, setFieldValue }) => {
        let formData = new FormData();
        formData.append("file", values.file);
        await uploadFile(formData);
        // Always clear the file after an upload attempt (success or failure)
        clearFile(setFieldValue);
        fetchData();
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
        setFieldValue,
        status,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          {uploadSuccess && (
            <Alert severity="success" my={3}>
              Hotel User uploaded successfully!
            </Alert>
          )}
          {uploadError && (
            <Alert severity="error" my={3}>
              {uploadErrorMessage || "Failed to upload file"}
            </Alert>
          )}
          <TextField
            variant="standard"
            error={Boolean(touched.file && errors.file)}
            fullWidth
            helperText={touched.file && errors.file}
            label="Upload file *"
            margin="normal"
            name="file"
            inputRef={fileInputRef}
            onChange={(event) => {
              resetUploadState();
              setFieldValue("file", event.currentTarget.files[0]);
            }}
            type="file"
            InputProps={{
              endAdornment: values.file && (
                <IconButton
                  onClick={() => {
                    clearFile(setFieldValue);
                    resetUploadState();
                  }}
                  size="small"
                >
                  <ClearIcon />
                </IconButton>
              ),
            }}
          />

          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              endIcon={isUpload ? <CircularProgress size={24} /> : null}
              disabled={isUpload}
            >
              Upload
            </Button>
            <Button
              disabled={isDownload}
              variant="contained"
              color="primary"
              onClick={() => downloadSampleFile()}
              endIcon={isDownload ? <CircularProgress size={24} /> : null}
            >
              Download Sample File{" "}
            </Button>
            <Button variant="text" onClick={() => unSetDialog("upload_users")} color="primary">
              Close
            </Button>
          </DialogActions>
        </form>
      )}
    </Formik>
  );
};
export default Upload;
